import { render } from "./WorkspaceCard.vue?vue&type=template&id=ca478b3c&scoped=true&ts=true"
import script from "./WorkspaceCard.vue?vue&type=script&lang=ts"
export * from "./WorkspaceCard.vue?vue&type=script&lang=ts"

import "./WorkspaceCard.vue?vue&type=style&index=0&id=ca478b3c&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca478b3c"]])

export default __exports__